import { render, staticRenderFns } from "./UnsavedChangesConfirmation.vue?vue&type=template&id=771e92b1"
import script from "./UnsavedChangesConfirmation.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports